import { IonContent, IonPage } from '@ionic/react';

import { Flex, Text } from '@servicetitan/anvil2';

import { UnableToLoadGenericIllustration } from './unable-to-load-generic';

export const UnavailablePage = () => {
    return (
        <IonPage>
            <IonContent>
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    style={{ height: '100%', padding: '24px' }}
                    className="a2-p-inline-6"
                >
                    <Flex
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        style={{ maxWidth: '445px' }}
                    >
                        <UnableToLoadGenericIllustration
                            width={80}
                            height={80}
                            className="a2-m-block-end-6"
                        />
                        <Text
                            variant="headline"
                            el="h1"
                            size="large"
                            style={{ textAlign: 'center' }}
                            className="a2-m-block-end-4"
                        >
                            We're Having Trouble Loading Fleet Pro
                        </Text>
                        <Text variant="body" style={{ textAlign: 'center' }}>
                            Something went wrong while trying to load Fleet Pro. Please refresh the
                            page. If the issue continues, contact our support team for further
                            assistance.
                        </Text>
                    </Flex>
                </Flex>
            </IonContent>
        </IonPage>
    );
};
